export function encodeBase64(str: string): string {
  const bytes = new TextEncoder().encode(str);
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte),
  ).join('');
  return btoa(binString);
}

export function decodeBase64(str: string): string {
  const binString = atob(str);
  const bytes = Uint8Array.from(
    binString,
    (character) => character.codePointAt(0)!,
  );
  return new TextDecoder().decode(bytes);
}

export function encodeBase64Url(str: string): string {
  return encodeBase64(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function decodeBase64Url(str: string): string {
  try {
    const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '=='.slice(0, (4 - (base64.length % 4)) % 4);
    return decodeBase64(padded);
  } catch (e) {
    return str;
  }
}
